/**
 * [M20] The workspace this tab just deleted, so the workspace list can offer to undo it (spec §13.10).
 * Per tab and in memory only: after a reload, restoring is the server administrator's job.
 */
import { useSyncExternalStore } from "react";

export interface DeletedWorkspace {
  id: string;
  name: string;
}

let current: DeletedWorkspace | null = null;
const listeners = new Set<() => void>();

export function setDeletedWorkspace(next: DeletedWorkspace | null): void {
  current = next;
  for (const l of listeners) l();
}

export function useDeletedWorkspace(): DeletedWorkspace | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
